import { render, staticRenderFns } from "./NameComponent.vue?vue&type=template&id=2dbb1ca2&scoped=true&"
import script from "./NameComponent.vue?vue&type=script&lang=js&"
export * from "./NameComponent.vue?vue&type=script&lang=js&"
import style0 from "./NameComponent.vue?vue&type=style&index=0&id=2dbb1ca2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dbb1ca2",
  null
  
)

export default component.exports